import {
    fastAuthorization, fastLogin,
    fetchUser,
    login,
    register, updateUserData, uploadFiles,
} from "./serverInterationMethods";
import {errorHandler} from "@/lib/errorHandler";

// store with all authenticated user data
export const user = {
    state: {
        // authorization user token for api
        token: null,
        user: null,
        whiteHeader: false,
        isGuestSession: sessionStorage.getItem('guestSession') === "true"
    },
    mutations: {
        // setting token state
        setToken(state, data) {
            state.token = data;
            if (state.token) {
                localStorage.setItem('token', data);
            } else {
                localStorage.removeItem('token');
            }
        },
        setUser(state, data) {
            state.user = data;
        },
        changeUserHeader(state, data) {
            state.whiteHeader = data;
        },
        setGuestSession(state, data) {
            state.isGuestSession = data;
            if (state.isGuestSession) {
                sessionStorage.setItem('guestSession', data);
            } else {
                sessionStorage.removeItem('guestSession');
            }
        }
    },
    actions: {
        submitGuestAuthorization({commit}) {
            commit('setGuestSession', true);
        },
        // gets user auth token from cookies if needed
        async loadUserToken({getters, commit}) {
            if (getters.token || getters.isGuestSession) return;
            let token = localStorage.getItem('token');
            if (token) {
                commit('setToken', token);
            }
        },
        // default user authorization method. Saves token in cookies if success
        async login({getters, commit, dispatch}, userData) {
            if (getters.token) return;

            let {data, status} = await login(userData);
            if (status === 200) {
                dispatch('logout');
                localStorage.setItem('token', data.token);
                commit('setToken', data.token);
            }
            errorHandler({name: 'login', status});
        },
        // default new user register method
        async register({getters}, data) {
            if (getters.token) return;
            const {status} = await register(data);
            errorHandler({name: 'registration', status});
        },
        async fastAuthorization({getters}, phone) {
            if (getters.token) return;
            const {status} = await fastAuthorization({phone});
            errorHandler({name: 'login', status, meta: {code: true}});
        },
        async fastLogin({getters, commit, dispatch}, code) {
            if (getters.token) return;
            const {status, data} = await fastLogin(code);
            if (status === 200) {
                dispatch('logout');
                localStorage.setItem('token', data.token);
                commit('setToken', data.token);
            }
            errorHandler({name: 'login', status});
        },
        async uploadFile(_, file) {
            let formData = await new FormData();
            await formData.append("file", file);
            const {data} = await uploadFiles(formData);
            return data.url;
        },
        async updateUserData({getters}, user) {
            const {status, data} = await updateUserData(getters.token, user);
            errorHandler({name: 'registration', status, meta: {data}});
            return status;
        },
        // default logout method. Clear auth token from Storage (cookies by default)
        logout({commit, getters}) {
            if (getters.token) {
                commit('setToken', null);
            } else if (getters.isGuestSession) {
                commit('setGuestSession', false);
            }
        },
        async fetchUser({commit, getters}) {
            if (!getters.token) return;
            const {data} = await fetchUser(getters.token);
            commit('setUser', data.user);
        }
    },
    getters: {
        // get default user auth token
        token: (state) => state.token,
        user: state => state.user,
        whiteHeader: state => state.whiteHeader,
        isGuestSession: state => state.isGuestSession
    }
};